import { render } from "./SaleDocumentPrint.vue?vue&type=template&id=173a7937&scoped=true"
import script from "./SaleDocumentPrint.vue?vue&type=script&lang=js"
export * from "./SaleDocumentPrint.vue?vue&type=script&lang=js"

import "./SaleDocumentPrint.vue?vue&type=style&index=0&id=173a7937&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173a7937"]])

export default __exports__